<template>
  <div class="cmp-booking-reports-main-container">
    <div class="main-header">
      <div>
        <h4>{{ $t("artist_report") }}</h4>
        <span>{{ $t("fill_in_the_following_report") }}</span>
      </div>
      <div>
        <button style="margin: 0px" @click="reset" class="dt-button v5 s8">
          {{ $t("reset_selection") }}
        </button>
      </div>
    </div>
    <div class="content-container">
      <div class="left-box">
        <div class="box date-box">
          <span>{{$t('time_period')}}</span>
          <div class="date-form">
            <DatePicker2
              id="start_date"
              style="width: 100%; margin-right: 30px"
              :showLabel="false"
              :placeholder="$t('start_date')"
              :value="reportParam.start_date"
              @input="onDateUpdate"
            />
            <DatePicker2
              id="end_date"
              :showLabel="false"
              :placeholder="$t('end_date')"
              style="width: 100%"
              :value="reportParam.end_date"
              @input="onDateUpdate"
            />
          </div>
        </div>
        <div class="box">
          <span>{{$t('information')}}</span>
          <div class="box-form">
            <div class="form-content">
              <Dropdown2
                id="user_id"
                :placeholder="$dft.capHead($t('agent'))"
                :disabled="false"
                :showLabel="false"
                :options="agentTV"
                style="width: 100%; margin-right: 30px"
                :selected="agentTV.find((e) => e.value == reportParam.user_id)"
                v-on:selectedChange="(e) => onDropdownChange('user_id', e)"
              />
              <div style="width: 100%" class="fc2 fc2-row ut-flex">
                <div class="ut-flex no-left-padding">
                  <div
                    class="no-label"
                    v-for="status in artistReport.statuslist"
                    :key="status.booking_status_id"
                  >
                    <span
                      v-if="
                        reportParam.booking_status_id ==
                        status.booking_status_id
                      "
                      class="circle"
                      :style="{
                        backgroundColor: `#${status.booking_status_colour}`,
                      }"
                    ></span>
                  </div>
                  <Dropdown2
                    id="booking_status_id"
                    :placeholder="$dft.capHead($t('status'))"
                    :disabled="false"
                    :showLabel="false"
                    :options="statusesTV"
                    :bb="'0px'"
                    :selected="
                      statusesTV.find(
                        (e) => e.value == reportParam.booking_status_id
                      )
                    "
                    v-on:selectedChange="
                      (e) => onDropdownChange('booking_status_id', e)
                    "
                  />
                </div>
              </div>
            </div>

            <div class="form-content">
              <TextField2
                id="city"
                :showLabel="false"
                style="width: 100%; margin-right: 30px"
                :placeholder="$dft.capHead($t('city'))"
                :value="reportParam.city"
                @blur="(e) => onTextFieldValueChange(e)"
              />
              <Dropdown2
                id="country"
                :placeholder="$dft.capHead($t('country'))"
                :disabled="false"
                :showLabel="false"
                :options="countriesTV"
                style="width: 100%"
                :selected="
                  countriesTV.find((e) => e.value == reportParam.country)
                "
                v-on:selectedChange="(e) => onDropdownChange('country', e)"
              />
            </div>
            <div class="form-content">
              <TextField2
                id="booking_location_id"
                :showLabel="false"
                style="width: 100%"
                :placeholder="$dft.capHead($t('venue'))"
                :value="selectedVenueName"
                @blur="(e) => onTextFieldValueChange(e)"
              />
              <div
                @click="openModal('venue_selection_modal')"
                style="
                  margin-right: 30px;
                  border-bottom: 1px solid var(--sprt-85);
                "
                class="dt-icon-container"
              >
                <img
                  style="height: 31px"
                  src="static/icons/lupe-blue.svg"
                  class="dt-icon v5 s3"
                  alt
                />
              </div>
              <TextField2
                id="contact_id_promoter"
                :showLabel="false"
                style="width: 100%"
                :placeholder="$dft.capHead($t('promoter'))"
                :value="selectedPromoterName"
                @blur="(e) => onTextFieldValueChange(e)"
              />
              <div
                style="border-bottom: 1px solid var(--sprt-85)"
                @click="openModal('promoter_selection_modal')"
                class="dt-icon-container"
              >
                <img
                  style="height: 31px"
                  src="static/icons/lupe-blue.svg"
                  class="dt-icon v5 s3"
                  alt
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="right-box">
        <div class="box">
          <span style="padding-bottom: 5px">{{ $t("artist") }}</span>
          <div class="box-form">
            <SelectTree :tree="permTypeTree" @changed="onPermTreeChange" />
          </div>
        </div>
        <div class="check-buttons">
          <img
            @click="onCheckAllCheckbox"
            :src="`static/icons/arrows/${
              selectedAll ? 'checkbox-tick' : 'checkbox'
            }.svg`"
            class="dt-icon checkbox"
          />
          {{ $t("select_all") }}
        </div>
        <div class="action-box">
          <button
            @click="generateBookingReport"
            style="height: 28px"
            class="dt-button"
          >
            {{ $t("create_report") }}
          </button>
        </div>
      </div>
    </div>

    <ModalContainer :modalKey="'venueSelectionModal'" :width="'medium'">
      <VenueSelectionModal
        @cancelled="onDialogCancelled"
        @set_venue="onSetVenueAdded"
      />
    </ModalContainer>

    <ModalContainer :modalKey="'promoterSelectionModal'" :width="'medium'">
      <PromoterSelectionModal
        @cancelled="onDialogCancelled"
        @set_promoter="onSetPromoterAdded"
      />
    </ModalContainer>
  </div>
</template>
  
  <script>
import { SelectTree } from "../../../../plugins/select-tree";
//import { ReportService } from "../../services/reports.service";
import {
  createModalMixin,
  openModalRoute,
} from "../../../../dt-plugins/modal/modal.mixin";
import ModalContainer from "@dtplugins/modal/modal-container";
//import MenuButton from "./menuButton.vue";
import {
  NotificationService,
  showNotification,
  showError,
} from "../../../../dt-plugins/notification/notification.service";
import { BookingService, BOOKING_URL } from "../../services/booking-service";
import { BookingStoreNamespace as storeNS } from "../../store";
import * as ActionTypes from "../../store/types";
import { mapActionObject, mapGetterObject } from "../../../../store/global";
import InputField from "../../../../plugins/text-field/input-field";
import { createTV } from "../../../../models/text-value.model";
import { EventHooks } from "../../../../plugins/text-field";
import { mapActions, mapGetters, mapMutations } from "vuex";
import VenueSelectionModal from "./venue-selection-modal";
import PromoterSelectionModal from "./promoter-selection-modal";
import FileDownload from "js-file-download";
import { Subject } from "rxjs";
import { distinctUntilChanged, debounceTime } from "rxjs/operators";
export default {
  components: {
    SelectTree,
    ModalContainer,
    InputField,
    VenueSelectionModal,
    PromoterSelectionModal,
  },
  props: [],
  data() {
    return {
      reportParam: this.getDefaultReportParam(),
      selectedVenueName: "",
      selectedPromoterName: "",
      selectedArtists: [],
      selectedAll: false,
      citySearchSubject$: new Subject(),
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        validationEvent: EventHooks.OnKeyup,
        isModel: true,
      },
    };
  },
  watch: {},
  computed: {
    ...mapGetters(storeNS, {
      artistReport: "bookingReportsArtistReport",
    }),
    statusesTV: function () {
      return (
        (this.artistReport.statuslist &&
          this.artistReport.statuslist.map((e) => ({
            text: e.booking_status_name,
            value: e.booking_status_id,
          }))) ||
        []
      );
    },
    agentTV: function () {
      return (
        (this.artistReport.userlist &&
          this.artistReport.userlist.map((e) => ({
            text: e.user_name,
            value: e.user_id,
          }))) ||
        []
      );
    },
    countriesTV: function () {
      return (
        (this.artistReport.countries &&
          this.artistReport.countries.map((e) => ({
            text: e,
            value: e,
          }))) ||
        []
      );
    },
    permTypeTree: function () {
      return (
        (this.artistReport.artistlist &&
          this.artistReport.artistlist.map((artist, index) => {
            return {
              text: artist.artist_name,
              value: artist.artist_id,
              selected: artist.selected,
              expanded: false,
              path: [index],
              children: [],
            };
          })) ||
        []
      );
    },
  },
  created() {},
  mixins: [
    createModalMixin("venueSelectionModal"),
    createModalMixin("promoterSelectionModal"),
  ],
  mounted: function () {
    this[ActionTypes.GET_BOOKING_REPORTS_ARTIST_REPORT]();
    // City Subscription
    this.$subscribeTo(
      this.citySearchSubject$
        .asObservable()
        .pipe(debounceTime(300), distinctUntilChanged()),
      (searchString) => {
        console.error(searchString);

        BookingService.findCountriesOfCity({
          city: searchString,
        }).then((res) => {
          if (res.data.countries && res.data.countries.length > 0) {
            this.reportParam.country = res.data.countries[0].country;
          }
        });
      }
    );
  },
  methods: {
    ...mapActions(storeNS, {
      [ActionTypes.GET_BOOKING_REPORTS_ARTIST_REPORT]:
        ActionTypes.GET_BOOKING_REPORTS_ARTIST_REPORT,
    }),
    onCheckAllCheckbox() {
      this.selectedAll = !this.selectedAll;
      this.artistReport.artistlist = this.artistReport.artistlist.map((p) => {
        p.selected = this.selectedAll;
        return p;
      });
      this.reportParam.artist_id = this.artistReport.artistlist
        .filter((e) => e.selected === true)
        .map((e) => e.artist_id);
    },
    onTextFieldValueChange: function (event) {
      const { name, value } = event;
      this.reportParam[name] = value;
      if (name == "city") {
        this.citySearchSubject$.next(value);
      }
    },
    onDropdownChange: function (name, value) {
      this.reportParam[name] = value.value;
    },
    onSetVenueAdded: function (payload) {
      this.selectedVenueName = payload.venue_name;
      this.reportParam["booking_location_id"] = payload.booking_location_id;
      this.onDialogCancelled();
    },

    onSetPromoterAdded: function (payload) {
      this.selectedPromoterName = payload.promoter_name;
      this.reportParam["contact_id_promoter"] = payload.promoter_id;
      this.onDialogCancelled();
    },

    onDateUpdate: function ({ name, value }) {
      console.log({ name, value });
      this.reportParam[name] = value;
    },
    reset: function () {
      this.reportParam = this.getDefaultReportParam();
      this.selectedVenueName = null;
      this.selectedPromoterName = null;
      this.selectedArtists = [];
      this.selectedAll = false;
      this.artistReport.artistlist = this.artistReport.artistlist.map((p) => {
        p.selected = false;
        return p;
      });
    },
    openModal(e) {
      openModalRoute(this, e, {
        mode: "add",
      });
    },
    onDialogCancelled: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined,
        },
      });
    },
    onPermTreeChange(artists) {
      console.log("e", artists);
      this.reportParam.artist_id = artists
        .filter((e) => e.selected === true)
        .map((e) => e.value);
      this.selectedAll =
        artists.filter((e) => e.selected).length == artists.length
          ? true
          : false;
      console.log(":::", this.reportParam.artist_id);
    },
    generateBookingReport() {
      let reportParams = {
        ...this.reportParam,
      };
      Object.keys(reportParams).forEach((key) => {
        if (reportParams[key] == null || reportParams[key] == "") {
          reportParams[key] = "0";
        }
      });
      console.log("reportParams", reportParams);
      BookingService.getBookingReportGenerate(reportParams).then((res) => {
        FileDownload(res.data, "booking_report.xlsx");
      });
    },
    getDefaultReportParam() {
      return {
        start_date: null,
        end_date: null,
        artist_id: null,
        booking_status_id: null,
        city: null,
        country: null,
        booking_location_id: null,
        contact_id_promoter: null,
        user_id: null,
      };
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.cmp-booking-reports-main-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  height: calc(100vh - 190px);
  padding: 0 10px;
  overflow: hidden;
  padding-top: 10px;
  max-width: 1800px;
  @media only screen and (max-width: 1800px) {
    max-width: 1245px;
  }
  .main-header {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    padding-bottom: 10px;
    h4 {
      color: #282828;
      font-weight: 500;
      text-transform: uppercase;
      opacity: 1;
      font: normal normal bold 13px/18px Roboto;
    }
  }
  .content-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    overflow: hidden;
    margin-top: 10px;
    @media (min-width: 320px) and (max-width: 800px) {
      flex-direction: column;
    }
    .left-box {
      width: 100%;
      margin-right: 20px;

      @media only screen and (min-width: 1800px) {
        margin-right: 20px;
        display: flex;
      }
      .box {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        border: 1px solid #c8c8c880;
        padding: 5px 15px 15px 15px;
        border-radius: 5px;
        width: 100%;
        margin-bottom: 20px;
        height: fit-content;
        max-width: 600px;
        &:hover {
          --fc2-bc: var(--bc-cblue);
          border: 1px solid #9b9a9a80;
        }
        &.date-box {
          @media only screen and (min-width: 1800px) {
            margin-right: 20px;
          }
        }
        .date-form {
          display: flex;
          flex-direction: row;
          width: 100%;
        }
        .box-form {
          display: flex;
          flex-direction: column;
          width: 100%;
          .form-content {
            display: flex;
            margin: 5px 0px 5px 2px;
          }
        }
      }
    }
    .right-box {
      width: 100%;
      overflow: hidden;
      height: 100%;
      display: flex;
      flex-direction: column;
      @media only screen and (min-width: 1800px) {
        width: 50%;
      }
      .box {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        border: 1px solid #c8c8c880;
        padding: 5px 15px 35px 15px;
        border-radius: 5px;
        width: 100%;
        overflow: hidden;
        height: 100%;
        max-width: 600px;
        &:hover {
          --fc2-bc: var(--bc-cblue);
          border: 1px solid #9b9a9a80;
        }
        .box-form {
          display: flex;
          flex-direction: row;
          width: 100%;
          min-height: 100%;
          overflow: auto;
          scrollbar-width: thin;
        }
      }
      .check-buttons {
        margin: 5px 0px 0px 15px;
        color: #828282;
      }
      .checkbox {
        width: 25px;
        height: 25px;
        padding: 4px;
      }
      .dt-checkbox.v2 {
        --size: 13px;
        --border-radius: 2px;
        --border-color: var(--border-color);
        --background-color: var(--bc-darker);
        --cm-height: 5px;
        --cm-width: 10px;
        --cm-top: 1px;
        --cm-left: 1px;
        --cm-color: #fff;
        margin-top: 3px;
      }
      img.dt-icon {
        margin: -4px -6px -7px -4px;
      }
      .action-box {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        width: 100%;
        .dt-button {
          margin-right: 2px !important;
          padding: 0 10px;
        }
      }
    }
  }
  .v3 {
    font-weight: 400 !important;
    color: #0087ff;
    opacity: 1;
  }
  .menu-container {
    margin-top: 0px !important;
  }
  .fc2-row {
    //--fc2-tf-padding: 0px 0px;
    //--fc2-tf-margin: 3px 3px 3px 0px;
    --bb: 1px solid var(--sprt-85);

    height: 30px;
    border-bottom: var(--bb);

    .fc2-label,
    .icon,
    .title {
      flex: 1;
    }
    .fc2-label,
    .title-txt {
      max-width: 115px;
    }
    > .ut-flex {
      flex: 1;
      padding: var(--fc2-tf-padding);
      margin: var(--fc2-tf-margin);
      min-width: 0;
      outline: none;

      &.no-left-padding {
        padding-left: 0;
      }

      span {
        display: block;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
    .icon {
      min-height: 22px;
      justify-content: flex-end;
    }

    .dropdown-2 {
      flex: 1;
    }

    .no-label {
      .fc2-label {
        display: none;
      }
    }
    .circle {
      margin-left: 10px;
    }
  }
}
</style>